import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Query from "@arcgis/core/rest/support/Query";
import { MapQueryOperator } from "../models/map-query-operator.model";
import { MapQuery } from "../models/map-query.model";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { SessionStorageEnum } from "../../../../shared/services/storage/session-storage-constants";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import StorageUtils from "../../../../shared/utils/storage-utils";
import { BehaviorSubject } from "rxjs";
import * as query from "@arcgis/core/rest/query";
let MapSearchService = class MapSearchService {
    sessionStorageService;
    mapLocation = new BehaviorSubject("");
    mapLocationAsObservable = this.mapLocation.asObservable();
    constructor(sessionStorageService) {
        this.sessionStorageService = sessionStorageService;
    }
    changeMapLocation(selectedPropertyId) {
        this.mapLocation.next(selectedPropertyId);
    }
    async doSearchWithAdditionalColumn(url, text, column, returnGeometry, additionalColumnValue, additionalColumn) {
        const featureSet = await this.searchItemByAttribute(url, text, column, returnGeometry, false, additionalColumnValue, additionalColumn);
        return this.transformFeatureSet(featureSet);
    }
    async doSearch(url, text, column, returnGeometry, returnTopOne) {
        let featureSet;
        if (text) {
            // @ts-ignore
            if (column && column === SharedConstants.SEARCH_BY_DEFAULT) {
                featureSet = await this.searchAllItems(url, returnGeometry);
            }
            else {
                // assert type
                featureSet = await this.searchItemByAttribute(url, text, column, returnGeometry, returnTopOne);
            }
        }
        else {
            featureSet = await this.searchAllItems(url, returnGeometry);
        }
        return this.transformFeatureSet(featureSet);
    }
    getSelectedSystemModule() {
        const selectedModuleID = this.sessionStorageService.get(SessionStorageEnum.SelectedModuleID);
        // @ts-ignore
        return StorageUtils.convertSessionStorageStringToNumber(selectedModuleID);
    }
    transformFeatureSet(featureSet) {
        const searchTypeList = new Array();
        if (!featureSet) {
            return searchTypeList;
        }
        featureSet.features.forEach((feature) => {
            searchTypeList.push(feature);
        });
        return searchTypeList;
    }
    async searchAllItems(url, returnGeometry, returnTopOne) {
        return query.executeQueryJSON(url, this.buildQuery("1=1", returnGeometry, returnTopOne));
    }
    async searchItemByAttribute(url, text, column, returnGeometry, returnTopOne, additionalColumnValue, additionalColumn) {
        let where = returnTopOne ? MapQuery.doOperation(column, text, MapQueryOperator.EqualsTo) : MapQuery.doOperation(column, text, MapQueryOperator.Like);
        if (additionalColumn && additionalColumnValue) {
            where += ` AND ${MapQuery.doOperation(additionalColumn, additionalColumnValue, MapQueryOperator.EqualsTo)}`;
        }
        return query.executeQueryJSON(url, this.buildQuery(where, returnGeometry, returnTopOne));
    }
    buildQuery(whereClause, returnGeometry, returnTopOne) {
        const newQuery = new Query();
        newQuery.where = whereClause;
        newQuery.returnGeometry = returnGeometry;
        newQuery.outFields = ["*"];
        if (returnTopOne) {
            newQuery.maxRecordCountFactor = 1;
        }
        newQuery.outSpatialReference = new SpatialReference({
            wkid: 102100
        });
        return newQuery;
    }
    static ctorParameters = () => [
        { type: SessionStorageService }
    ];
};
MapSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MapSearchService);
export { MapSearchService };
